<!-- eslint-disable -->
<template>
    <div>
        <SvgPanZoom v-if="load_panzoom"
            style="width: 100%; "
            :zoomEnabled="true"
            :controlIconsEnabled="false"
            :fit="true"
            :center="true"
            :mouseWheelZoomEnabled="false"
            :zoomScaleSensitivity="2"
            :dblClickZoomEnabled="false"
            :preventMouseEventsDefault="false"
            @svgpanzoom="registerSvgPanZoom"
            class="svgpanzoom-container"
        >
            <component v-bind:is="place.component_name" :zonas="zonas" @clickZona="clickZona" :zona_id="zona_id" :can_click="can_click" @cargado="loaded = true"></component>
        </SvgPanZoom>

        <template v-else>
            <component v-bind:is="place.component_name" :zonas="zonas" @clickZona="clickZona" :zona_id="zona_id" :can_click="can_click"></component>
        </template>

        <template v-if="load_panzoom">
            <button @click="zoomIn()" class="button panzoom-button">+</button>
            <button @click="zoomOut()" class="button panzoom-button">-</button>
        </template>

        <template v-if="loaded">
            <template v-for="zona in zonas">
                <PopOverComponent :key="zona.id" :zona="zona" :zona_id="zona_id" :libres="getAsientosLibres(zona)"></PopOverComponent>
            </template>
        </template>    
        
    </div>
</template>

<script>
    import SvgPanZoom from 'vue-svg-pan-zoom';
    import PopOverComponent from './components/PopOverComponent';

    export default {
        components : {
            SvgPanZoom, PopOverComponent,
            nueva_condomina: () => import('./CondominaComponent'),
        },

        props : ['zonas', 'zona_id', 'can_click', 'popup_enabled', 'occupied', 'place'],

        computed: {
            renovacion() {
                var dni = this.$route.query.dni;
                var n_abonado_antiguo = this.$route.query.n_abonado_antiguo;

                if(dni && n_abonado_antiguo) {
                    return 1;
                } else {
                    if(this.$route.name == 'front.abonos.renovar.index') {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            }
        },

        data() {
            return {
                svgpanzoom : null,
                load_panzoom : true,
                os : null,
                loaded: false
            }
        },
        created() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if(/windows phone/i.test(userAgent)) {
                this.load_panzoom = false;
            }

            if(/android/i.test(userAgent)) {
                this.load_panzoom = false;
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                this.load_panzoom = false;
            }
        },
        methods : {
            getAsientosLibres(zona) {
                if(zona.libres >= 0) {
                    return zona.libres;
                }

                if(zona.libres < 0) {
                    return 0;
                }

                var aforo = 0;

                if(!zona.with_seats) {
                    aforo = zona.aforo;
                } else {
                    aforo = zona.total_asientos;
                }

                aforo = aforo - zona.confirmados - zona.bloqueados - zona.no_confirmados - zona.sesion;

                if(aforo < 0) {
                    aforo = 0;
                }

                return aforo;
            },
            registerSvgPanZoom (svgpanzoom) {
                this.svgpanzoom = svgpanzoom;
            },
            zoomIn : function() {
                this.svgpanzoom.zoomIn();
            },
            zoomOut : function() {
                this.svgpanzoom.zoomOut();
            },

            clickZona : function(zona) {
                if(this.$route.name == 'back.events.sesion.bloquear-asientos' || this.$route.name == 'back.abonos.bloquear-asientos' || this.$route.name == 'back.abonos.index' || this.$route.name == 'back.abonados.show'  || this.$route.name == 'back.events.venta' || this.$route.name == 'superadmin.butacas.ocultar') {
                    this.$emit('clickZona', zona);
                } else if(this.can_click && zona.esta_disponible && this.getAsientosLibres(zona) > 0 && zona.precios.length > 0) {
                    this.$emit('clickZona', zona);
                }
            },
            getTotalVenta(zona) {
                var aforo = 0;

                if(!zona.with_seats) {
                    aforo = zona.aforo;
                } else {
                    aforo = zona.total_asientos;
                }

                return aforo - zona.count_bloqueados;
            }
        }
    }
</script>
